import { debounce } from 'underscore';
import { useCallback, useMemo, useState, useEffect } from 'react';

export const useDebouncedState = (initialState, delayMs) => {
  const [value, setValue] = useState(initialState);
  const [newValue, setNewValue] = useState(initialState);
  const setValueDebouncedInternal = useMemo(() => debounce(setValue, delayMs), [delayMs]);
  const setValueDebounced = useCallback((valueToSet) => {
    setNewValue(valueToSet);
    setValueDebouncedInternal(valueToSet);
  }, [setValueDebouncedInternal]);

  useEffect(() => () => {
    setValueDebouncedInternal.cancel();
  }, [setValueDebouncedInternal]);

  return [value, setValueDebounced, newValue];
};
